export default __webpack_public_path__ + "static/buidlhub-4b44da58d5a8f1dc70b474ab813934c7.jpg";